import {
  OfferShippingDetailsSettings,
  offerShippingDetailsSettingsSchema,
} from "@made-people/grease-structured-data";
import { useStructuredDataSettings } from "./use-structured-data-settings";

export const useGetOfferShippingDetailsSettings = ():
  | OfferShippingDetailsSettings
  | undefined => {
  const structuredDataSettings = useStructuredDataSettings();

  if (!structuredDataSettings) {
    return undefined;
  }

  const offerShippingDetails = structuredDataSettings[0]?.offerShippingDetails;

  const parsedOfferShippingDetails =
    offerShippingDetailsSettingsSchema.safeParse(offerShippingDetails);

  if (!parsedOfferShippingDetails.success) {
    return undefined;
  }

  return parsedOfferShippingDetails.data;
};
